import { Directive, ElementRef, Input, NgModule, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appHideParentIfEmpty]'
})
export class HideParentIfEmptyDirective {

  @Input('appHideParentIfEmpty') element: ElementRef;

  constructor(private renderer2: Renderer2) { }

  hideElement(hideClass = 'd-none') {
    if (this.element) {
      this.renderer2.addClass(this.element, hideClass);
    }
  }

  showElement(hideClass = 'd-none') {
    if (this.element) {
      this.renderer2.removeClass(this.element, hideClass);
    }
  }

}
@NgModule({
  declarations: [HideParentIfEmptyDirective],
  exports: [HideParentIfEmptyDirective],
})
export class HideParentIfEmptyModule { }
